module.exports = __webpack_public_path__ + "media/קו.1b83aa77.mp3";